import React, { useEffect, useState, useCallback } from 'react';
import '../switchUser.css';
import StartShiftModal from './startShiftModal';
import SwitchUserModal from './switchUserModal';
import userManagement from '../../../services/userManagement';
import ApiService from '../../../services/apiService';
import { useNavigate } from 'react-router-dom';

const SwitchUserScreen = () => {
  const [showSwitchModal, setShowSwitchModal] = useState(null);
  const [showStartShiftModal, setShowStartShiftModal] = useState(false);
  const [activeUser, setActiveUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const currentUserId = userManagement.getUserId(localStorage.getItem('Token'));

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('Token');
      if (!token) {
        setError('No authentication token found');
        return;
      }

      const apiService = new ApiService();
      const data = await apiService.get('GET_LOGGEDIN_EMPLOYEE');

      //   if (!data?.result) {
      //     setError('No user data received');
      //     return;
      //   }

      const filtered = data?.result?.data.filter((user) => user?.userId !== currentUserId);
      setUsers(filtered);
    } catch (err) {
      console.error('Error fetching users:', err);
      setError(err.message || 'Error fetching users');
    } finally {
      setLoading(false);
    }
  }, [currentUserId]);

  const handleSwitchUserPress = async (user) => {
    if (!user?.userId) {
      setError('Invalid user data');
      return;
    }

    setActiveUser(user.userId);
    setError(null);

    if (user.isLoggedIn) {
      // User is already logged in, show passcode modal
      setShowSwitchModal({
        visible: true,
        user,
        mode: 'passcode',
      });
    } else {
      // User needs to log in - show login modal instead of using stored password
      setShowSwitchModal({
        visible: true,
        user,
        mode: 'login',
      });
    }
  };

  const handleUserLogin = async (credentials) => {
    try {
      const apiService = new ApiService();
      const response = await apiService.post('USER_LOGIN', credentials);

      if (response?.data?.accessToken) {
        localStorage.setItem('Token', response.data.accessToken);

        if (response?.data?.userCompanies?.[0]) {
          localStorage.setItem('Company', JSON.stringify(response.data.userCompanies[0]));
        }

        console.log('🔐 User logged in successfully');

        // Refresh the user list to reflect new login status
        await fetchUsers();

        // Navigate to home or refresh
        window.location.href = '/home';
      } else {
        throw new Error('No token received from server');
      }
    } catch (err) {
      console.error('Login failed:', err);
      setError('Login failed: ' + (err.message || 'Unknown error'));
      throw err; // Re-throw to handle in modal
    }
  };

  const handleStartShiftPress = () => {
    setActiveUser('startShift');
    setShowStartShiftModal(true);
    setError(null);
  };

  const handleModalClose = () => {
    setShowSwitchModal(null);
    setShowStartShiftModal(false);
    setActiveUser(null);
  };

  const handleSwitchSuccess = async () => {
    console.log('✅ User switch successful');

    // Refresh user list
    await fetchUsers();

    // Navigate to home
    window.location.pathname = 'Cashier/home';
    // navigate('');
  };

  if (loading) {
    return (
      <div className="switch-user-container">
        <div className="loading-spinner">Loading users...</div>
      </div>
    );
  }

  return (
    <div className="switch-user-container">
      {/* {error && (
        <div className="error-banner">
          <p className="error-text">{error}</p>
          <button className="retry-button" onClick={fetchUsers} disabled={loading}>
            Retry
          </button>
        </div>
      )} */}

      <div className="grid-container">
        <button className={`user-button start-shift ${activeUser === 'startShift' ? 'active' : ''}`} onClick={handleStartShiftPress} disabled={loading}>
          <span className="button-icon">+</span>
          Start Shift
        </button>

        {users?.map((user) => {
          const username = user?.employee_Name || user?.name || 'Unknown User';
          const isActive = activeUser === user.userId;
          const isLoggedIn = user.isLoggedIn;

          return (
            <button
              key={user.userId}
              className={`user-button ${isActive ? 'active' : ''} ${isLoggedIn ? 'logged-in' : 'logged-out'}`}
              onClick={() => handleSwitchUserPress(user)}
              disabled={loading}
              title={isLoggedIn ? 'User is logged in' : 'User needs to log in'}
            >
              <span className="username">{username}</span>
              {isLoggedIn && <span className="status-indicator">●</span>}
            </button>
          );
        })}
      </div>

      {showStartShiftModal && <StartShiftModal visible={showStartShiftModal} onClose={handleModalClose} onSuccess={handleSwitchSuccess} />}

      {showSwitchModal?.mode === 'passcode' && (
        <SwitchUserModal visible={showSwitchModal.visible} user={showSwitchModal.user} onVerified={handleSwitchSuccess} onClose={handleModalClose} />
      )}

      {showSwitchModal?.mode === 'login' && (
        <StartShiftModal
          visible={showSwitchModal.visible}
          user={showSwitchModal.user}
          onClose={handleModalClose}
          onSuccess={handleSwitchSuccess}
          title={`Login as ${showSwitchModal.user?.employee_Name || 'User'}`}
        />
      )}
    </div>
  );
};

export default SwitchUserScreen;
